__turbopack_context__.v({
  "badgeInfoWrapper": "index-module-scss-module__cHaixW__badgeInfoWrapper",
  "carousel": "index-module-scss-module__cHaixW__carousel",
  "description": "index-module-scss-module__cHaixW__description",
  "icon": "index-module-scss-module__cHaixW__icon",
  "iconWrapper": "index-module-scss-module__cHaixW__iconWrapper",
  "info": "index-module-scss-module__cHaixW__info",
  "infoIcon": "index-module-scss-module__cHaixW__infoIcon",
  "infoText": "index-module-scss-module__cHaixW__infoText",
});
